import { render, staticRenderFns } from "./Estudante-pesquisa-geral-ims.vue?vue&type=template&id=9c8a3428&scoped=true&"
import script from "./Estudante-pesquisa-geral-ims.vue?vue&type=script&lang=js&"
export * from "./Estudante-pesquisa-geral-ims.vue?vue&type=script&lang=js&"
import style0 from "./Estudante-pesquisa-geral-ims.vue?vue&type=style&index=0&id=9c8a3428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8a3428",
  null
  
)

export default component.exports